import axios from "axios";
import url from "../config/urlServiceConfig";

const authAPI = {
  login: body => axios.post(`${url.login}/Login`, body)
};

export default authAPI;
